<script lang="ts">
	import { Icons } from '$lib/components/icon'
	import { Icon } from '@repo/ui'
	import { Headline } from '@repo/ui'

	interface Props {
		headline: string
		description: string
		children?: import('svelte').Snippet
	}

	let { headline, description, children }: Props = $props()
</script>

<Headline>
	<div class="flex items-center space-x-4">
		<span class="text-4xl text-green-400">
			{headline}
		</span>
		<Icon class="h-10 w-10 text-green-400" solid src={Icons.CheckCircle} />
	</div>
</Headline>

<p class="mt-4">
	{description}
</p>

{@render children?.()}
